import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { setCurrentUser } from '../../ducks/user.duck';

export const updatePurposeThunk = createAsyncThunk(
  'OnboardingPage/updatePurpose',
  (publicDataPayload, { dispatch, rejectWithValue, extra: sdk }) => {
    return sdk.currentUser
      .updateProfile({ publicData: publicDataPayload }, { expand: true })
      .then(response => {
        const entities = denormalisedResponseEntities(response);
        if (!entities.length) throw new Error('Empty response from updateProfile');
        const currentUser = entities[0];
        dispatch(setCurrentUser(currentUser));
        return currentUser;
      })
      .catch(e => rejectWithValue(storableError(e)));
  }
);

export const updatePurpose = payload => dispatch => dispatch(updatePurposeThunk(payload));

const onboardingSlice = createSlice({
  name: 'OnboardingPage',
  initialState: { updateInProgress: false, updateError: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(updatePurposeThunk.pending, state => {
        state.updateInProgress = true;
        state.updateError = null;
      })
      .addCase(updatePurposeThunk.fulfilled, state => {
        state.updateInProgress = false;
      })
      .addCase(updatePurposeThunk.rejected, (state, action) => {
        state.updateInProgress = false;
        state.updateError = action.payload;
      });
  },
});

export default onboardingSlice.reducer;
